<template>
	<div style="margin: 20px 30px 0">
		<div id="wrap" v-cloak>
			<div class="tanchuang" id="tanchuang2" style="width: 5.8cm;font-size:16px">
				<p style="padding-top: 20px;width: 100%;text-align: center">MOMYHOME结课</p>
				<p style="width: 100%;height: 10px;border-top:2px dashed #999"></p>
				<p>会员姓名：<span>{{dayin.username}}</span></p>
				<p>课程名称：<span>{{dayin.kc_name}}</span></p>
				<p>老师：<span>{{dayin.teacher}}</span></p>
				<p><span>总课时：<span>{{dayin.z_number}}</span></span></p>
				<p>
					<span>耗课时：<span>{{dayin.xiaohao}}</span></span>
					<span>剩余课时：<span>{{dayin.y_keshi}}</span></span>
				</p>
				<p><span>上课时间：<span>{{dayin.sktime}}</span></span></p>
				<p><span>教室：<span>{{dayin.jiaoshi}}</span></span></p>
				<p style="width: 100%;height: 2px;border-top:2px dashed #999"></p>
				<p id="dyxp">{{dayin.dyxp}}</p>
				<p style="width: 100%;height: 2px;border-top:2px dashed #999"></p>
				<p style="width: 100%;text-align: center"><span class="dayintime" id="dayintime">{{dayin.time}}</span></p>
				<p style="width: 100%;text-align: center"><span class="centerabc" id="centerabc">{{dayin.centre}}</span></p>
				<p style="width: 100%;text-align: center">联系电话：<span class="phone1abc" id="phone1abc">{{dayin.c_phone}}</span></p>
			</div>


			<el-dialog title="温馨提示" :visible.sync="showalert" width="30%" center :close-on-click-modal="false">
				<div style="text-align: center;height:80px;vertical-align: middle">

					<img src="/static/qmsj/img/newcontract/tanhao.png" style="vertical-align: middle" height="40" alt="">
					<span style="font-size: 20px;vertical-align: middle">返回签到页面</span>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button class="btnfont" type="warning" style="background: #E6BE8A;color: #ffffff;width: 100px;padding: 10px;border-radius: 30px;"
					 @click="showback">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
	import purBtn from '@/components/btn.vue'
	import weitap from '@/components/weitap'
	export default {
		components: {
			purBtn,
			weitap
		},
		data() {
			return {
				token: '',
				showalert: false,
				aid: '',
				uid:'',
				dayin:'',
			}
		},
		mounted() {
			let self = this;
			self.token = $.cookie('token');
			self.aid = this.$route.query.a_id;
			self.uid = this.$route.query.u_id;
			self.get_info()
		},
		methods: {
			showback() {
				this.$router.push('qiandao')
			},
			getQueryVariable(variable) {
				var query = window.location.search.substring(1);
				var vars = query.split("&");
				for (var i = 0; i < vars.length; i++) {
					var pair = vars[i].split("=");
					if (pair[0] == variable) {
						return pair[1];
					}
				}
				return (false);
			},
			get_info() {
				let self = this;
				$.ajax({
					'type': 'post',
					'url': process.env.apiUrl + "saas/qiandaot/get_print_info",
					'data': {
						'token': self.token,
						pk_id: self.aid,
						user_id: self.uid,
					},
					'success': function(data) {
						console.log(data)
						if(data.status==1){
							self.dayin=data.data
						setTimeout(function() {
							window.print();
							window.opener=null;
							window.open('','_self');
							window.close();
						}, 900)
						}

					}
				})
			}
		}

	}
</script>
<style media="print">
	@page {
		size: auto;
		/* auto is the initial value */
		margin: 0mm;
		/* this affects the margin in the printer settings */
	}
</style>
<style scoped>
	.head {
		padding: 10px 45px 0;
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
		border-bottom: 1px solid #bdb8e0;
	}

	* {
		font-size: 16px;
		margin: 0;
		padding: 0;
	}

	[v-cloak] {
		display: none;
	}

	li {
		list-style: none;
	}

	body {
		margin: 30px 40px;
	}

	#wrap {
		width: 210mm;
		height: 294mm;
		/*border: 1px solid gainsboro;*/
		padding: 15px 50px 15px 0;
		box-sizing: border-box;
	}

	.el-date-editor.el-input,
	.el-date-editor.el-input__inner {
		width: 130px;
	}

	.el-input--prefix .el-input__inner {
		border-color: gainsboro;
	}

	.el-radio__input.is-checked .el-radio__inner {
		border-color: gainsboro;
		background: gray;
	}

	.el-radio__input.is-checked+.el-radio__label {
		color: black;
	}

	.el-dialog__header {
		background: #E6BE8A;
		color: #FFFFFF;
	}

	.el-dialog__title {
		color: #FFFFFF;
		font-size: 22px;
	}

	.btnfont>span {
		font-size: 18px;
	}

	.dia_header {
		padding: 12px 12px 12px 30px;
		background-color: gainsboro;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
	}

	.search_inp {
		height: 24px;
		margin-left: 30px;
		padding-left: 10px;
		outline: none;
		border: 1px solid gray;
		border-radius: 2px;
		margin-right: 5px;
	}

	.search_sel {
		height: 26px;
		padding-right: 10px;
		padding-left: 5px;
	}

	.el-input-number--mini {
		width: 100px;
	}

	.el_close {
		color: rgb(255, 255, 255);
		font-size: 24px;
		float: right;
		padding-right: 18px;
		cursor: pointer;
	}

	.el-button {
		padding: 6px 10px;
	}

	.el-button:active {
		color: gray;
		border-color: grey;
	}

	.el-button:hover {
		color: gray;
		border-color: grey;
		background-color: gainsboro;
	}

	.el-pager li.active {
		color: gray;
	}

	.el-pager li:hover {
		color: gray;
	}

	.input_num {
		width: 60px;
		height: 23px;
		text-align: center;
		border: 1px solid grey;
		border-radius: 3px;
	}

	.el-table td,
	.el-table th {
		padding: 6px 0;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: gainsboro;
		border-color: gray;
	}

	input[]:invalid,
	input:focus:invalid,
	textarea[]:invalid,
	textarea:focus:invalid {
		box-shadow: none;
	}

	#content {
		width: 210mm;
		height: 294mm;
		padding: 15px 50px 15px 0;
		box-sizing: border-box;
	}

	.el-dialog__headerbtn {
		display: none;
	}

	.right_bottom {
		display: none !important;
	}

	.topbar,
	.right_top,
	.navbar-box {
		display: none !important;
	}
</style>



// WEBPACK FOOTER //
// src/pages/qiandao/printing.vue